<template>
  <div>
    <div class="relative pb-16 mx-auto" style="width: 800px">
      <div class="py-8">
        <router-link :to="{ name: 'NotificationIndex' }" class="absolute">
          <div class="flex items-center">
            <img src="@/assets/icons/ListReturnIcon.svg" />
            <div class="text-gray-92 leading-8 ml-2">お知らせ一覧に戻る</div>
          </div>
        </router-link>
      </div>

      <div class="mt-8 bg-white rounded-lg px-20 py-12">
        <div class="text-xl font-semibold">{{ state.subject }}</div>
        <div class="mt-3 mb-7 leading-4">{{ state.startAt }}</div>
        <div
          class="leading-6 notification-content"
          v-html="state.content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject, reactive } from 'vue';
import EditorJSHtml from 'editorjs-html';
import axios from '@/utils/axios.js';

export default {
  props: {
    notificationId: Number,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const state = reactive({
      startAt: '',
      subject: '',
      content: '',
    });
    onMounted(async () => {
      await axios
        .get(`/user-notifications/${props.notificationId}`)
        .then((response) => {
          let notificationData = response.data.data;
          state.subject = notificationData.subject;
          state.startAt = notificationData.start_at;

          let jsonData = JSON.parse(notificationData.content);
          const parser = EditorJSHtml();
          state.content = parser.parse(jsonData).reduce((x, y) => `${x}${y}`);
          //結果をv-htmlで反映する。
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    });

    return { state };
  },
};
</script>

<style lang="scss" scoped>
.notification-content {
  :deep(b) {
    @apply font-semibold;
  }
  :deep(ol) {
    list-style: decimal;
    padding-left: 1rem;
  }
  :deep(ul) {
    list-style: inherit;
    padding-left: 1.25rem;
  }
  :deep(p mark),
  :deep(ul li mark),
  :deep(ol li mark) {
    background: rgba(245, 235, 111, 0.29);
  }
  :deep(p code),
  :deep(ul li code),
  :deep(ol li code) {
    background: rgba(250, 239, 240, 0.78);
    color: #b44437;
    padding: 3px 4px;
    border-radius: 5px;
    margin: 0 1px;
    font-family: inherit;
    font-size: 0.86em;
    font-weight: 500;
    letter-spacing: 0.3px;
  }
  :deep(p a),
  :deep(ul li a),
  :deep(ol li a) {
    text-decoration: underline;
    @apply text-gray-92;
  }
}
</style>
